import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient.ts'
import {parseAxiosPromise} from '@/axiosInstance.ts'
import {httpMe} from '@features/user/http/user.http.ts'
import {User} from '@features/user/types.ts'
import {captureException} from '@sentry/react'

export const useMe = (options?: Omit<UseQueryOptions<unknown, unknown, User>, 'queryFn' | 'queryKey'>) =>
    useQuery({
        queryKey: [QUERY_KEYS.ME],
        queryFn: () =>
            parseAxiosPromise({
                axiosPromise: httpMe(),
                responseShape: User,
                onZodError: options?.throwOnError ? undefined : captureException
            }),
        ...options
    })
